export default __webpack_public_path__ + "static/media/alejandro_.ace241b6.png";